import Error from '../model/Error';
import Sport from '../dto/offering/Sport';
import axios from 'axios';

export default class SportsRepository {

    static findAll(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offerings/sports`)
                .then(response => resolve(response.data.data.map(data => Sport.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findAllWithArchived(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offerings/sports?withArchived=true`)
                .then(response => resolve(response.data.data.map(data => Sport.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static bulkUpdate(clubId, sports) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/offerings/sports/bulk`, {
                    'sports': sports.map(data => data.serialize()),
                })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
